module.exports = __webpack_public_path__ + "img/dragoonsoft.b0549453.png";